import * as types from './constants';

const initialState = {
  max_variants: null,
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Lookbook Limits
  [types.GET_LOOKBOOK_LIMITS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_LIMITS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_LIMITS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
